import { PropsWithChildren } from "react";
import {
  usePopoverContext,
  UsePopoverContext,
  Popover as ArkPopover,
  PopoverRootProps,
  Portal,
} from "@ark-ui/react";
import classnames from "classnames";

import styles from "./popover.module.css";

interface PopoverProps {
  rootProps?: PopoverRootProps;
  trigger: PopoverTriggerType;
  /** Raise above widget editor dialogs (1501). Matches nested modal overlay tier. */
  nested?: boolean;
}

interface PopoverTriggerProps {
  trigger: PopoverTriggerType;
}

type PopoverTriggerType =
  | React.ReactNode
  | ((context: UsePopoverContext) => React.ReactNode);

export default function Popover({
  rootProps,
  children,
  trigger,
  nested = false,
}: PropsWithChildren<PopoverProps>) {
  return (
    <ArkPopover.Root portalled {...rootProps}>
      <PopoverTrigger trigger={trigger} />
      <Portal>
        <ArkPopover.Positioner>
          <ArkPopover.Content
            className={classnames(styles.popoverContent, nested && styles.popoverNested)}
          >
            {children}
          </ArkPopover.Content>
        </ArkPopover.Positioner>
      </Portal>
    </ArkPopover.Root>
  );
}

function PopoverTrigger({ trigger }: PopoverTriggerProps) {
  const context = usePopoverContext();

  return (
    <ArkPopover.Trigger asChild>
      {typeof trigger === "function" ? trigger(context) : trigger}
    </ArkPopover.Trigger>
  );
}
